import { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  withStyles,
} from '@material-ui/core';
import { Link } from '@material-ui/icons';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';
const ColorButton = withStyles((theme) => ({
  root: {
    color: '#062e6f !important',
    borderRadius: '20px !important',
    background: '#fff !important',
    border: '1px solid #062e6f !important',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.1) !important',
    },
  },
}))(Button);

const LinkButton = withStyles((theme) => ({
  root: {
    color: '#062e6f !important',
    borderRadius: '20px !important',
    backgroundColor: 'white !important',
    display: 'flex !important',
    '&:hover': {
      backgroundColor: '#91b6f8 !important',
    },
  },
}))(Button);

const CopyPublicLink = ({ open = false }) => {
  const { closePublicLinkModal } = useRoleplayStore();
  const { token, tempTitle, closeModal } = PublicRealPlayHelper();

  const handleClose = () => {
    closePublicLinkModal();
    closeModal();
  };
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    let baseURL = process.env.REACT_APP_PUBLIC_ROLEPLAY;
    const text = `${baseURL}/public-roleplay/${token}`;
    try {
      await navigator.clipboard.writeText(text || '');
      setCopied(true);

      // reset status after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Error al copiar: ', err);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="public-dialog-title">Share "{tempTitle}" roleplay</DialogTitle>
      <DialogContent>
        <LinkButton startIcon={<Link />} onClick={handleCopy}>
          Copy Link{' '}
        </LinkButton>
        {copied && <p style={{ color: 'green' }}>Copied!</p>}
      </DialogContent>
      <DialogActions>
        <ColorButton onClick={handleClose}>Close</ColorButton>
      </DialogActions>
    </Dialog>
  );
};

export default CopyPublicLink;
